import api from './api';

export interface EnderecoResponsavelDto {
  endereco: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade: string;
  estado: string;
  cep: string;
}

export interface Responsavel {
  id: number;
  nome: string;
  cpfCnpj: string;
  email?: string;
  telefone?: string;
  tipoPessoa?: number;
  endereco?: EnderecoResponsavelDto;
  ativo: boolean;
}

export interface CreateResponsavelDto {
  nome: string;
  cpfCnpj: string;
  email: string;
  telefone: string;
  tipoPessoa: number;
  rg?: string;
  dataNascimento?: string;
  nacionalidade?: string;
  estadoCivil?: string;
  profissao?: string;
  grauInstrucao?: string;
  localTrabalho?: string;
  rendaMensal?: number;
  declaraIR?: boolean;
  ativo?: boolean;
  telefoneResidencial?: string;
  telefoneComercial?: string;
  endereco?: EnderecoResponsavelDto;
  inscricaoEstadual?: string;
  inscricaoMunicipal?: string;
  razaoSocial?: string;
}

export const responsaveisService = {
  async getAll(): Promise<Responsavel[]> {
    const { data } = await api.get('/responsaveis');
    return data;
  },

  async getAtivos(): Promise<Responsavel[]> {
    const { data } = await api.get('/responsaveis?ativos=true');
    return data;
  },

  async getById(id: number): Promise<Responsavel> {
    const { data } = await api.get(`/responsaveis/${id}`);
    return data;
  },

  async create(payload: CreateResponsavelDto): Promise<Responsavel> {
    const { data } = await api.post('/responsaveis', payload);
    return data;
  },
};
